/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StarIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function StarIcon({
  children,
  viewPath = "/DesignSystem/Svgs/StarIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="StarIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-1CFw96': alignSelf,'--mt-2-1CFw96': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1CFw96': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1CFw96': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1CFw96': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1CFw96': opacity,'--w-7-1CFw96': typeof width === 'number' ? `${width}px` : width,'--h-8-1CFw96': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="StarIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M3.4 13.2l8.7-1.3L16 4l3.9 7.9 8.7 1.3-6.3 6.2 1.5 8.7-7.8-4.2L8.2 28l1.5-8.7-6.3-6.1z"
 style={{'--f-9-1CFw96': fill,'--s-10-1CFw96': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}